import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export function ThemeToggle({ className = "", iconSize = 18 }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      onClick={toggleTheme}
      data-testid="theme-toggle"
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Light mode" : "Dark mode"}
      className={`grid place-items-center rounded-xl transition-colors ${className}`}
    >
      {isDark
        ? <Sun style={{ width: iconSize, height: iconSize }} aria-hidden="true" />
        : <Moon style={{ width: iconSize, height: iconSize }} aria-hidden="true" />}
    </button>
  );
}
